@if (deckCard) {
    <div class="fixed inset-0 w-screen h-screen overflow-y-auto bg-gray-500 text-slate-900 bg-opacity-70 p-2 z-[100]">
        <div class="flex items-center justify-center pt-20">
            <div class="w-[400px] h-[600px] bg-slate-50 rounded shadow flex flex-col">
                <div class="flex flex-row bg-ponder-light text-slate-50 stroke-slate-50 rounded-t shadow pr-2">
                    <div class="p-2 grow">Versions of '{{ deckCard.card.item.name }}'</div>
                    <div (click)="onCloseClicked()" class="w-8 h-8 p-2 stroke-faded-50 hover:stroke-white hover:cursor-pointer">
                        <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                            <title>Close</title>
                            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="closeSvgIcon" />
                        </svg>
                    </div>
                </div>
                <div class="flex flex-col overflow-y-auto grow">
                    <loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
                    @if (!isLoading && loadingSuccess) {
                        @if (!hasAlternateVersionsToShow()) {
                            <div class="p-2">
                                There are no alternate versions of <span class="italic">{{ deckCard.card.item.name }}</span>
                            </div>
                        } @else {
                            @for (alternateVersion of alternateVersions ; track alternateVersion.item.id!) {
                                @if (shouldShow(alternateVersion)) {
                                    <div (click)="onVersionSelected(alternateVersion)" class="p-1 pl-2 pr-2 flex flex-row gap-2 group hover:bg-ponder-linkhover hover:bg-opacity-25 hover:cursor-pointer w-full" [ngClass]="{ 'bg-ponder-linkhover bg-opacity-5' : isCollected(alternateVersion)}">
                                        <div class="w-[150px] min-w-[150px]">
                                            <img loading="lazy" [attr.src]="getCardImageUrl(alternateVersion)" class="mtg-card-rounded-sm card-shadow w-full h-[210px]">
                                        </div>
                                        <div class="flex flex-col gap-1">
                                            <div class="flex flex-row gap-1 items-center align-middle">
                                                <div class="font-bold w-[20ch]">
                                                    <label [attr.title]="getTooltipName(alternateVersion)">
                                                        {{ getShortenedName(alternateVersion) }}
                                                    </label>
                                                </div>
                                                <div class="w-5 h-5">
                                                    @if (isCollected(alternateVersion)) {
                                                        <svg class="w-5 h-5 fill-none stroke-ponder-link opacity-70" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                                                            <title>Close</title>
                                                            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="collectedSvgIcon" />
                                                        </svg>
                                                    }
                                                </div>
                                            </div>
                                            <div class="flex flex-row gap-2 text-xs pb-1">
                                                <div>{{ getReleaseDate(alternateVersion) }}</div>
                                                <div class="text-slate-400">|</div>
                                                <div>{{ getSetIndex(alternateVersion) }}</div>
                                            </div>
                                            <div class="pt-4">
                                                <table class="table-auto text-sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Version</th>
                                                            <th class="pl-3">Value</th>
                                                            <th class="pl-3">Count</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Normal</td>
                                                            <td class="pl-3">{{ getCardValue(alternateVersion) }}</td>
                                                            <td class="pl-3">{{ getCollectedCount(alternateVersion) }}</td>
                                                        </tr>
                                                        <tr class="text-foil-dark">
                                                            <td>Foil</td>
                                                            <td class="pl-3">{{ getCardSpecialValue(alternateVersion) }}</td>
                                                            <td class="pl-3">{{ getCollectedSpecialCount(alternateVersion) }}</td>
                                                        </tr>
                                                        @if (getProxyCount(alternateVersion)) {
                                                            <tr class="text-slate-400">
                                                                <td>Proxy</td>
                                                                <td class="pl-3"></td>
                                                                <td class="pl-3">{{ getProxyCount(alternateVersion) }}</td>
                                                            </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                }
                            }
                        }
                        
                    }
                </div>
                <div class="p-2 flex flex-row gap-2 align-middle border-t text-sm bg-slate-100 rounded-b">
                    @if (alternateVersions) {
                        <div>
                            <input #setFilterInput (input)="onFilterUpdated(setFilterInput)" type="text" class="w-[18ch] p-2" placeholder="Filter on Set ...">
                        </div>
                        <div class="p-2 flex flex-row gap-2 items-center align-middle grow">
                            <input #collectedOnlyCheckbox (change)="onCheckboxToggle(collectedOnlyCheckbox)" type="checkbox" id="collectedOnly" name="collectedOnly">
                            <label for="collectedOnly">Collected Only</label>
                        </div>
                    }
                    <div>
                        <button (click)="onCloseClicked()" class="p-2 w-20 bg-slate-50 hover:bg-white rounded-sm shadow">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
}